import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteFavoriteExerciseSessionItem } from '../../../../api/diary-service';

const useDeleteFavoriteExerciseSession = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteFavoriteExerciseSessionItem,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['favoriteExerciseSessions'] });
        }
    });
};

export default useDeleteFavoriteExerciseSession;
